import { render } from "./ProfileCard.vue?vue&type=template&id=31acd55a"
import script from "./ProfileCard.vue?vue&type=script&lang=js"
export * from "./ProfileCard.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "31acd55a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31acd55a', script)) {
    api.reload('31acd55a', script)
  }
  
  module.hot.accept("./ProfileCard.vue?vue&type=template&id=31acd55a", () => {
    api.rerender('31acd55a', render)
  })

}

script.__file = "src/ui/services/ProfileCard.vue"

export default script